import React, { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import httpClient from "../../api/module/httpClient";
import CustomButton from "../Button";
import Checkbox from "../Checkbox";
import { notification } from "antd";
import { CERTIFICATE } from "../../enum/QueryKeys";

export default function WithdrawTab({ certificateId, certificateUser, slug }) {

  const [checked, setChecked] = useState(false);

  const { data } = useQuery({
    queryKey: ["WITHDRAW_DESCRIPTION"],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificate-withdrawal-description/`);

      return data;
    },
  });

  const queryClient = useQueryClient();

  const requestWithdrawMutation = useMutation({
    mutationFn: () => {
      return httpClient.post(`private/certificate/${certificateId}/request-withdraw`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CERTIFICATE, slug]);

      notification.success({
        message: "Success",
      });
    },
    onError: () => {
      notification.error({
        message: "Something went wrong.",
      });
    },
  });

  const handleBtnOnClick = () => {
    if (!checked) {
      return notification.warn({
        message: "Please check the checkbox to withdraw",
      });
    }

    requestWithdrawMutation.mutate();
  };

  return (
    <div>
      {certificateUser?.hasRequestedToWithdraw ? (
        <h1>You have requested to withdraw from this program. We will review and approve your request within the next 24 hours. You will receive a confirmation email.</h1>
      ) : (
        <>
          <div style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: data?.withdrawDescription}} />


          <div style={{ marginTop: "1rem" }}>
            <Checkbox checked={checked} onChange={() => setChecked(prev => !prev)}>Click the checkbox if you agree with
              the
              terms.</Checkbox>
          </div>
          <div style={{ marginTop: "1rem" }}>
            <CustomButton text={"Withdraw"} onClick={handleBtnOnClick} loading={requestWithdrawMutation.isLoading} />
          </div>
        </>
      )}
    </div>
  );
}